import React from 'react'
import styled from 'styled-components'
import MagicHeader from 'components/magic/MagicHeader'
import {
  magicContainerStyle,
  titleStyle1,
  textStyle1,
} from 'components/magic/styled'

const Section = styled.section`
  position: relative;
  width: 100%;
  padding-bottom: 30px;
`

const Container = styled.div`
  ${magicContainerStyle};
  text-align: center;
`

const Title = styled.h1`
  ${titleStyle1};
`

const Text = styled.p`
  ${textStyle1};
`

const ProductHeroSection = () => (
  <Section>
    <MagicHeader darkTheme />
    <Container>
      <Title>
        A shopping experience & ecosystem that begins and ends with people
      </Title>
      <Text>
        Your customers are both your ambassadors and content creators on Flip.
        Build trust by giving them the power to speak their minds on what they
        love the most about your brand.
      </Text>
    </Container>
  </Section>
)

export default ProductHeroSection
